import React from 'react';

export const LoaderBar: React.FC = () => {
    return (
        <div className="loadingProgressG">
            <div className="loadingProgressG2"></div>
        </div>
    );
};
